const WISHLIST_KEY = 'theme_wishlist';

function getWishlist() {
  return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
}

function saveWishlist(wishlist) {
  localStorage.setItem(WISHLIST_KEY, JSON.stringify(wishlist));
}

function isInWishlist(productId) {
  return getWishlist().some(item => item.id === productId);
}

function renderWishlistButtons() {
  const wishlist = getWishlist();

  document.querySelectorAll('.wishlist-button').forEach(button => {
    const productId = button.dataset.productId;

    const active = wishlist.some(item => item.id === productId);

    button.classList.toggle('is-active', active);
    button.setAttribute(
      'aria-label',
      active ? 'Favorilerden çıkar' : 'Favorilere ekle'
    );
  });
}

function toggleWishlist(button) {
  const productId = button.dataset.productId;
  const productHandle = button.dataset.productHandle;

  let wishlist = getWishlist();

  const exists = wishlist.some(item => item.id === productId);

  if (exists) {
    wishlist = wishlist.filter(item => item.id !== productId);
  } else {
    wishlist.push({
      id: productId,
      handle: productHandle
    });
  }

  saveWishlist(wishlist);
  renderWishlistButtons();

  document.dispatchEvent(new CustomEvent('wishlist:updated', {
    detail: { wishlist }
  }));
}

document.addEventListener('click', function(event) {
  const button = event.target.closest('.wishlist-button');

  if (!button) return;

  event.preventDefault();
  event.stopPropagation();

  toggleWishlist(button);
});

document.addEventListener('DOMContentLoaded', renderWishlistButtons);



function updateWishlistCount() {

  const wishlist = JSON.parse(
    localStorage.getItem('theme_wishlist')
  ) || [];

  const countElement = document.getElementById('WishlistCount');

  if (!countElement) return;

  countElement.textContent = wishlist.length;

  if (wishlist.length > 0) {
    countElement.style.display = 'flex';
  } else {
    countElement.style.display = 'none';
  }
}

document.addEventListener(
  'DOMContentLoaded',
  updateWishlistCount
);

document.addEventListener(
  'wishlist:updated',
  updateWishlistCount
);